import { render, staticRenderFns } from "./FBackButton.vue?vue&type=template&id=01fbdb72&"
import script from "./FBackButton.vue?vue&type=script&lang=js&"
export * from "./FBackButton.vue?vue&type=script&lang=js&"
import style0 from "./FBackButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports